module.exports = __webpack_public_path__ + "img/user_center_bg.6c550848.png";